import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import { FaAngleLeft } from 'react-icons/fa6';

import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps';


import './sendMoney.css'
import CurrencyExchangeComponent from '../../../../components/CurrencyConversion/CurrencyConverter';

const Step2SendMoney = ({ userDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdited, setIsEdited] = useState(false);
  const converterSendingDetails = location.state?.converterSendingDetails;
  const [txnAmountDetails, setTxnAmountDetails] = useState(converterSendingDetails || null);  
  const [isTxnDetailsEdited, setIsTxnDetailsEdited] = useState(false);

  const payload = location.state?.payload;

  const isPayloadEmpty = !payload || Object.values(payload).every(
    (value) => value === undefined || value === null || value === ''  
  );

  useEffect(() => {
    if (isPayloadEmpty) {
      navigate("/user/send_money/step1");
    }
  }, [isPayloadEmpty, navigate]);

  const handleGoBack = () => {
    navigate("/user/send_money/step1", { state: { selectedTransferLocation: payload.location, payload, txnAmountDetails } }); 
  }

  const handleContinue = () => {
    navigate("/user/send_money/step3"); 
  };
  return (
    <section className='create__card__page send__money__page' style={{ paddingTop: "30px" }}>
      <div className="container">
        <div className="d-flex align-items-center mb-2">
            <button 
              onClick={handleGoBack} 
              className="btn btn-sm d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm back-button-hover" 
              style={{ backgroundColor: '#fff', color: '#4a4a4a', border: '1px solid #eaeaea', transition: 'all 0.2s ease', fontWeight: '500' }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
                <FaAngleLeft size={14} />
                <span className="small">Go back</span>
            </button>
        </div>
      </div>
      <section className="mt-3"><CardsProgressSteps currentStep={2} stepLabels={["Recipient", "Amount", "Review/Pay", "Success"]} /></section>

      <div className="container px-0 mt-4">
        <div className="send__money__card send__money__form">
          <div className='create_card_header'>
              <h4 className='mb-0 text-center'>How much are you sending?</h4>
          </div>
          <CurrencyExchangeComponent 
            sendMoneyPage={true} 
            payload={payload}
            userDetails={userDetails} 
            setTxnAmountDetails={setTxnAmountDetails} 
            setIsTxnDetailsEdited={setIsTxnDetailsEdited}
            txnAmountDetails={txnAmountDetails}
          />

          {/* <div className="d-flex align-items-center justify-content-center mt-4 mx-2">
            <button onClick={handleContinue} className="btn primary__btn w-100 py-2">
              Continue
            </button>
          </div> */}
        </div>
      </div>
      
    </section>
  )
}

export default Step2SendMoney;